import { AppProps } from 'single-spa';
import { CHAT_BLK_LOAD_PARCEL_EVENT, URIS } from './constants';
import { ChatBlkAppContext } from './types';

import { mount } from './root';

declare global {
    interface Window {
        VITE_CHATBLK_API_KEY: string;
        VITE_PRE_PROD_AUTH: string;
        __CHATBLK_PARCEL_IS_INITIALIZED__?: boolean;
        __CHATBLK_PARCEL_LOADED__?: boolean;
        __CHATBLK_PARCEL_AUTOMOUNT__?: boolean;
        __CYPRESS_CHATBLK_APP_CONTEXT__?: Record<string, unknown>; // Define the type explicitly
        __CYPRESS_CHATBLK_ENV__?: string; // 'development' | 'production'
    }
}
const isPreProd = URIS.PRE_PROD_HOSTS.includes(window.location.hostname);
const mountEvent = isPreProd ? 'DOMContentLoaded' : CHAT_BLK_LOAD_PARCEL_EVENT;
const container = document.createElement('div');
window.__CHATBLK_PARCEL_IS_INITIALIZED__ = true;
container.id = 'chat-blk__host';
// Append the container to the DOM if not already present
if (!document.getElementById(container.id)) {
    document.body.appendChild(container);
}

const getAppContext = () => {
    return window.__CYPRESS_CHATBLK_APP_CONTEXT__
        ? { appContext: window.__CYPRESS_CHATBLK_APP_CONTEXT__ }
        : {};
};

/**
 * Will mount if the following conditions are met:
 * 1. `__CHATBLK_PARCEL_AUTOMOUNT__` flag to allow auto-mounting is not set to false.
 * 2. The current window is the top window or the parent window has not loaded the parcel.
 */
const shouldMount = () => {
    let parentParcelLoaded = false;
    try {
        parentParcelLoaded =
            window.parent && window.parent.__CHATBLK_PARCEL_IS_INITIALIZED__;
    } catch (e) {
        parentParcelLoaded = false;
    }
    return (
        window?.__CHATBLK_PARCEL_AUTOMOUNT__ !== false &&
        (window.top === window.self || !parentParcelLoaded) &&
        !window.__CHATBLK_PARCEL_LOADED__
    );
};

// Store the event listener in a variable so it can be removed properly
const chatBlkLoadParcelListener = async () => {
    await autoMount(mountEvent);
};
const autoMount = async (eventName: string) => {
    // Refresh appContext/config in case DOM or window context has changed
    const config = {
        name: 'chatblk',
        domElement: container,
        ...getAppContext(),
    };

    console.log(`[CHATBLK] Auto-mounting on event: ${eventName}`);
    if (shouldMount()) {
        await mount(config as unknown as ChatBlkAppContext & AppProps);
        window.__CHATBLK_PARCEL_LOADED__ = true;
    }

    window.removeEventListener(mountEvent, chatBlkLoadParcelListener);
};

(async () => {
    if (isPreProd) {
        if (document.readyState !== 'complete') {
            window.addEventListener(
                'DOMContentLoaded',
                chatBlkLoadParcelListener
            );
        } else {
            await autoMount('readyState complete');
        }
    } else {
        window.addEventListener(mountEvent, chatBlkLoadParcelListener);
    }
})();
